// extracted by mini-css-extract-plugin
export default {"consent-dropdown-container":"events-registration-client-js-components-___ConsentToPublishEditor-module__consent-dropdown-container___0HGIs"};